/**
 * Стартер для Multiplayer Battle
 * Вынесено из legacy-app.js для модульности
 */

import { createMultiplayerBattleManager } from "./multiplayerBattle.js";

/**
 * Показывает заставку с результатом боя
 * @param {string} result - Результат: 'victory', 'defeat', 'draw'
 * @param {string} reason - Причина окончания боя
 */
function showBattleResultScreen(result, reason) {
  // Удаляем старый overlay, если есть
  const oldOverlay = document.getElementById('battle-result-overlay');
  if (oldOverlay) {
    oldOverlay.remove();
  }
  
  // Используем body для гарантированного отображения поверх всего
  const container = document.body;
  if (!container) {
    console.error('[MultiplayerBattle] Body не найден для отображения результата');
    return;
  }
  
  // Создаём overlay для результата
  let resultOverlay = document.createElement('div');
  resultOverlay.id = 'battle-result-overlay';
  resultOverlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.95);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 99999;
    animation: fadeIn 0.5s ease-in;
  `;
  
  // Определяем контент в зависимости от результата
  let title = '';
  let emoji = '';
  let color = '';
  let message = '';
  
  let rewardText = '';
  // Проверяем, была ли отмена/прерывание игры
  const isCancelled = reason === 'opponent_disconnected' || 
                      reason === 'player_cancelled' || 
                      reason === 'cancelled';
  
  if (isCancelled) {
    // При отмене/прерывании игры награды НЕ выдаются
    title = 'БОЙ ПРЕРВАН';
    emoji = '🛑';
    color = '#ff6666';
    message = 'Соединение потеряно или бой отменён.';
    rewardText = ''; // Не показываем награды при отмене
  } else if (result === 'victory') {
    title = 'ПОБЕДА!';
    emoji = '🏆';
    color = '#4dfffd';
    message = 'Отличная игра!';
    rewardText = '<div style="margin-top: 20px; font-size: 18px; color: #4dfffd;">💰 +50 монет за победу<br>💰 +10 монет за участие</div>';
  } else if (result === 'defeat') {
    title = 'ПОРАЖЕНИЕ';
    emoji = '💀';
    color = '#ff6666';
    message = 'Не расстраивайся, попробуй ещё раз!';
    rewardText = '<div style="margin-top: 20px; font-size: 18px; color: #ffd700;">💰 +10 монет за участие</div>';
  } else {
    // Ничья (нормальная, не отмена)
    title = 'НИЧЬЯ';
    emoji = '🤝';
    color = '#ffd700';
    message = 'Равная борьба!';
    rewardText = '<div style="margin-top: 20px; font-size: 18px; color: #ffd700;">💰 +10 монет за участие</div>';
  }
  
  // Создаём контент
  resultOverlay.innerHTML = `
    <div style="
      text-align: center;
      animation: scaleIn 0.6s ease-out;
    ">
      <div style="
        font-size: 120px;
        margin-bottom: 20px;
        animation: bounce 1s ease-in-out infinite;
      ">${emoji}</div>
      <h1 style="
        font-size: 48px;
        font-weight: 900;
        color: ${color};
        margin: 0 0 16px 0;
        text-shadow: 0 0 30px ${color}80;
        letter-spacing: 4px;
      ">${title}</h1>
      <p style="
        font-size: 20px;
        color: rgba(255, 255, 255, 0.9);
        margin: 0 0 20px 0;
      ">${message}</p>
      ${rewardText}
      <div style="
        font-size: 14px;
        color: rgba(255, 255, 255, 0.6);
        margin-top: 20px;
        margin-bottom: 30px;
      ">Причина: ${reason === 'team_eliminated' ? 'Команда противника уничтожена' : 
                  reason === 'time_limit' ? 'Время истекло' : 
                  reason === 'opponent_disconnected' ? 'Противник отключился' : 
                  reason === 'player_cancelled' ? 'Бой отменён' : 
                  reason === 'storm_eliminated' ? 'Оба игрока выбыли из-за шторма' : 
                  'Неизвестно'}
      </div>
      <button id="close-result-btn" style="
        background: ${color};
        color: #000;
        border: none;
        padding: 12px 32px;
        border-radius: 8px;
        font-size: 16px;
        font-weight: 700;
        cursor: pointer;
        margin-top: 20px;
        transition: transform 0.2s, opacity 0.2s;
      " onmouseover="this.style.transform='scale(1.05)'" onmouseout="this.style.transform='scale(1)'">
        Закрыть
      </button>
    </div>
    <style>
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes scaleIn {
        from { 
          transform: scale(0.5);
          opacity: 0;
        }
        to { 
          transform: scale(1);
          opacity: 1;
        }
      }
      @keyframes bounce {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-20px); }
      }
      @keyframes fadeOut {
        from { opacity: 1; }
        to { opacity: 0; }
      }
    </style>
  `;
  
  // Добавляем overlay в контейнер
  container.appendChild(resultOverlay);
  
  // Функция закрытия заставки
  let closeTimeout = null;
  const closeResult = () => {
    if (closeTimeout) {
      clearTimeout(closeTimeout);
      closeTimeout = null;
    }
    if (resultOverlay && resultOverlay.parentNode) {
      resultOverlay.style.animation = 'fadeOut 0.5s ease-out';
      setTimeout(() => {
        if (resultOverlay && resultOverlay.parentNode) {
          resultOverlay.remove();
          resultOverlay = null;
        }
        // Обновляем балансы после закрытия экрана результата
        if (typeof window !== 'undefined' && typeof window.updateUserBalancesUI === 'function') {
          window.updateUserBalancesUI();
        }
      }, 500);
    }
  };
  
  // Обработчик кнопки "Закрыть"
  const closeBtn = resultOverlay.querySelector('#close-result-btn');
  if (closeBtn) {
    closeBtn.addEventListener('click', closeResult);
  }
  
  // Автоматически скрываем через 5 секунд (увеличено с 3)
  closeTimeout = setTimeout(closeResult, 5000);
  
  // Сохраняем ссылку для возможной очистки
  window.__lastBattleResultOverlay = { overlay: resultOverlay, close: closeResult, timeout: closeTimeout };
}

/**
 * Запускает мультиплеерный бой
 * @param {string} playerHeroId - ID героя игрока
 * @param {function} getTelegramWebAppSafe - функция получения Telegram WebApp
 * @param {object} multiplayerManagerRef - ссылка на менеджер мультиплеерного боя (для обновления)
 */
export function startMultiplayerBattle(playerHeroId, getTelegramWebAppSafe, multiplayerManagerRef) {
  const battleContainer = document.getElementById('glitchlings-battle-container');
  const selectionContainer = document.getElementById('glitchlings-hero-selection');
  const screen = document.getElementById('glitchlingsbattle-screen');
  const menuContent = screen?.querySelector('.menu-content');
  
  if (!battleContainer) return;
  
  // Скрываем выбор и другие элементы экрана
  if (selectionContainer) {
    selectionContainer.style.display = 'none';
  }
  
  // Скрываем header для полноэкранного режима
  const header = screen?.querySelector('.modern-header');
  if (header) {
    header.style.display = 'none';
  }
  
  // Скрываем кнопку "К обычным боям" и другие элементы
  const backButton = screen?.querySelector('button[onclick*="battle"]');
  if (backButton) {
    backButton.style.display = 'none';
  }
  
  // Убираем padding у menu-content для полноэкранного режима
  if (menuContent) {
    menuContent.style.padding = '0';
    menuContent.style.margin = '0';
    menuContent.style.height = '100vh';
    menuContent.style.overflow = 'hidden';
  }
  
  // Очищаем контейнер для мультиплеерного боя
  battleContainer.innerHTML = '';
  battleContainer.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: #0a0a1a;
    padding: 0;
    margin: 0;
    z-index: 1000;
    display: block;
  `;
  
  // Создаём контейнер для мультиплеерного боя
  const multiplayerContainer = document.createElement('div');
  multiplayerContainer.id = 'multiplayer-battle-container';
  multiplayerContainer.style.cssText = `
    position: relative;
    width: 100%;
    height: 100%;
  `;
  battleContainer.appendChild(multiplayerContainer);
  
  // Функция для получения initData
  function getTelegramInitData() {
    const telegram = getTelegramWebAppSafe();
    return telegram?.initData || null;
  }
  
  // Создаём менеджер мультиплеерного боя
  const multiplayerManager = createMultiplayerBattleManager({
    containerId: 'multiplayer-battle-container',
    onBattleEnd: (result) => {
      console.log('[MultiplayerBattle] Бой окончен:', result);
      
      // Получаем команду игрока из менеджера (исправлено: используем team вместо localPlayer?.team)
      const playerTeam = multiplayerManager?.team || null;
      const localPlayer = multiplayerManager?.localPlayer || null;
      
      // Нормализуем значения для сравнения (приводим к строке и lowercase)
      const normalizeTeam = (team) => {
        if (team === null || team === undefined) return null;
        return String(team).toLowerCase().trim();
      };
      
      const normalizedWinner = normalizeTeam(result.winner);
      const normalizedPlayerTeam = normalizeTeam(playerTeam || localPlayer?.team);
      
      console.log('[MultiplayerBattle] Определение результата:', {
        winner: result.winner,
        normalizedWinner,
        playerTeam: playerTeam,
        localPlayerTeam: localPlayer?.team,
        normalizedPlayerTeam,
        reason: result.reason,
        multiplayerManagerExists: !!multiplayerManager,
        teamGetter: typeof multiplayerManager?.team
      });
      
      if (!normalizedPlayerTeam) {
        console.error('[MultiplayerBattle] ❌ Команда игрока не определена!', {
          playerTeam,
          localPlayerTeam: localPlayer?.team,
          localPlayer: localPlayer,
          multiplayerManager: multiplayerManager
        });
      }
      
      // Проверяем, была ли отмена поиска ПЕРЕД определением результата
      const isCancelled = result.reason === 'opponent_disconnected' || 
                         result.reason === 'player_cancelled' || 
                         result.reason === 'cancelled';
      
      // Определяем результат боя с нормализованными значениями
      let battleResult = 'draw'; // 'victory', 'defeat', 'draw'
      
      // Если отмена - сразу показываем "БОЙ ПРЕРВАН" без определения результата
      if (isCancelled) {
        battleResult = 'draw'; // Не важно, главное что isCancelled = true
        console.log('[MultiplayerBattle] 🛑 Отмена поиска/боя:', result.reason);
      } else if (normalizedWinner === null || normalizedWinner === undefined || normalizedWinner === '') {
        battleResult = 'draw';
        console.log('[MultiplayerBattle] Ничья: winner === null/undefined/empty');
      } else if (normalizedWinner === normalizedPlayerTeam) {
        battleResult = 'victory';
        console.log('[MultiplayerBattle] ✅ Победа: winner === playerTeam', {
          winner: normalizedWinner,
          playerTeam: normalizedPlayerTeam
        });
      } else if (normalizedPlayerTeam !== null) {
        battleResult = 'defeat';
        console.log('[MultiplayerBattle] ❌ Поражение: winner !== playerTeam', {
          winner: normalizedWinner,
          playerTeam: normalizedPlayerTeam
        });
      } else {
        // Если команда игрока не определена, считаем ничьей
        battleResult = 'draw';
        console.log('[MultiplayerBattle] ⚠️ Ничья: команда игрока не определена');
      }
      
      console.log('[MultiplayerBattle] Финальный результат:', {
        battleResult,
        winner: normalizedWinner,
        playerTeam: normalizedPlayerTeam,
        reason: result.reason,
        isCancelled,
        match: normalizedWinner === normalizedPlayerTeam,
        winnerType: typeof normalizedWinner,
        playerTeamType: typeof normalizedPlayerTeam
      });
      
      // Показываем заставку с результатом (isCancelled проверяется внутри showBattleResultScreen)
      showBattleResultScreen(battleResult, result.reason || 'unknown');
      
      // Возвращаемся к выбору героя (увеличено время до 5 секунд, чтобы игрок успел увидеть результат)
      setTimeout(() => {
        try {
          if (multiplayerManager) {
            multiplayerManager.stopBattle();
            if (multiplayerManagerRef) {
              multiplayerManagerRef.current = null;
            }
          }
          
          // Восстанавливаем интерфейс (используем let вместо const для избежания конфликтов)
          const battleScreen = document.getElementById('glitchlingsbattle-screen');
          if (!battleScreen) {
            console.warn('[MultiplayerBattle] Экран боя не найден, возвращаемся на главный экран');
            if (typeof window.showScreen === 'function') {
              window.showScreen('home');
            }
            return;
          }
          
          const battleHeader = battleScreen.querySelector('.modern-header');
          const battleMenuContent = battleScreen.querySelector('.menu-content');
          const battleBackButton = battleScreen.querySelector('button[onclick*="battle"]');
          
          if (battleHeader) battleHeader.style.display = '';
          if (battleMenuContent) {
            battleMenuContent.style.padding = '';
            battleMenuContent.style.margin = '';
            battleMenuContent.style.height = '';
            battleMenuContent.style.overflow = '';
          }
          if (battleBackButton) battleBackButton.style.display = '';
          
          const battleContainerRestore = document.getElementById('glitchlings-battle-container');
          if (battleContainerRestore) {
            battleContainerRestore.style.cssText = 'display: none; padding: 0 20px 20px;';
          }
          
          // Показываем экран выбора героя вместо полной перезагрузки
          if (typeof window.loadGlitchlingsBattleScreen === 'function') {
            window.loadGlitchlingsBattleScreen();
          } else {
            // Fallback: возвращаемся на главный экран
            console.warn('[MultiplayerBattle] loadGlitchlingsBattleScreen не найдена, возвращаемся на главный экран');
            if (typeof window.showScreen === 'function') {
              window.showScreen('home');
            }
          }
        } catch (error) {
          console.error('[MultiplayerBattle] Ошибка при восстановлении интерфейса:', error);
          // В случае ошибки просто возвращаемся на главный экран
          if (typeof window.showScreen === 'function') {
            window.showScreen('home');
          }
        }
      }, 5000); // Увеличено с 2000 до 5000 мс
    },
    getTelegramInitData: getTelegramInitData
  });
  
  // Обновляем ссылку на менеджер
  if (multiplayerManagerRef) {
    multiplayerManagerRef.current = multiplayerManager;
  }
  
  // Запускаем бой
  multiplayerManager.startBattle(playerHeroId);
  
  return multiplayerManager;
}

